import React, { useEffect, useState, useRef } from 'react'
import BaseFilter from '../../components/BaseFilter'
import rotas from '../../services/rotas'
import { useNavigate } from 'react-router-dom'
import FilterButton from '../../components/buttons/FilterButton'
import { Grid, Box, Divider, IconButton } from '@mui/material'
import BaseTooltip from '../../components/BaseTooltip'
import HelpIcon from '@mui/icons-material/Help'
import {
  AdaptativeGridContainer,
  BaseAutoComplete,
  BaseDatePicker
} from '../../components/shared'
import {
  Add,
  FileDownload,
  FileUpload,
  OndemandVideo,
  ArticleOutlined,
  DeleteForever
} from '@mui/icons-material'
import DefaultPainel from '../../components/shared/Painel'
import VisualizarModal from './visualizarPostagem'
import VisualizarPlagio from './visualizarPlagio'
import gerarPaginacao from '../../services/pagination'
import TableHeader from '../../components/shared/tables/TableHeader'
import Dater from '../../services/DateFormat'
import Exportacao from '../../services/http/exports/Exportacao'
import Importacao from '../../services/http/imports/Importacao'
import { Logs, Postagens, StatusPostagens } from '../../services/http'
import SmallTextField from '../../components/textfield/SmallTextfield'
import PrivateRC from '../../components/PrivateRC'
import filter from './filters'
import { FormatPostagens, getMinDate } from './functions'
import { StyledBaseDatagrid } from './components'
import AutoCompleteClear from '../../components/autocomplete/AutocompleteClear'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'
import SearchStartAdornment from '../../components/adornment/SearchStartAdornment'
import MobileFilterHeaderContainer from '../../components/filters/MobileFilterHeaderContainer'

const tipoOptions = [
  {
    id: 1,
    descricao: 'Escrita',
    value: 'escrita'
  },
  { id: 2, descricao: 'Vídeo', value: 'video' }
]
const IconTipe = {
  video: <OndemandVideo color="redstrong" />,
  escrita: <ArticleOutlined color="green" />
}

const Postagem = () => {
  const [post, setPost] = useState([])
  const [queryLector, setQueryLector] = useState([])
  const [query, setQuery] = useState({})
  const [currentPage, setCurrentPage] = useState(0)
  const [lastPage, setLastPage] = useState(0)
  const [tloading, setTloading] = useState(false)
  const inputRef = useRef()

  let typingTimer = ''

  const headers = [
    {
      field: 'id',
      headerName: 'Cód.',
      flex: 0.7
    },
    {
      field: 'biblioteca',
      headerName: 'Biblioteca',
      flex: 1
    },
    {
      field: 'leitor',
      headerName: 'Leitor',
      flex: 1.3
    },
    {
      field: 'livro',
      headerName: 'Livro',
      flex: 3
    },
    {
      field: 'periodo',
      headerName: 'Período',
      flex: 0.9
    },
    {
      field: 'data',
      headerName: (
        <div className="d-flex align-center">
          Data Postagem
          <BaseTooltip
            title="hora referente ao horário de Brasília"
            followCursor
          >
            <HelpIcon />
          </BaseTooltip>
        </div>
      ),
      flex: 1.2
    },

    {
      field: 'postagem',
      headerName: 'Tipo',
      flex: 0.6,
      renderCell: ({ row }) => {
        return IconTipe[row.postagem]
      }
    },
    {
      field: 'paginas',
      headerName: 'Páginas',
      flex: 0.9
    },

    {
      field: 'statusRh',
      headerName: 'Status',
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <>
            <VisualizarPlagio postagem={row} />
          </>
        )
      }
    },
    {
      field: 'actions',
      headerName: 'Ações',
      renderCell: ({ row }) => {
        return (
          <>
            <VisualizarModal postagem={row} onChange={() => getPost(query)} />
            <PrivateRC roles="gestor">
              <IconButton
                onClick={() => {
                  confirmDelete(row.id, row.leitor)
                }}
                color="error"
              >
                <DeleteForever />
              </IconButton>
            </PrivateRC>
          </>
        )
      },
      flex: 1
    }
  ].map(item => ({ ...item, align: 'center', sortable: false }))

  // function formataFiltroAno(query) {
  //   if (query.ano == null) {
  //     delete query.ano
  //     return query
  //   }
  //   const created_at =
  //     parseInt(query.ano?.$y || new Date().getFullYear()) +
  //     '-01-01,' +
  //     (parseInt(query.ano?.$y || new Date().getFullYear()) + 1) +
  //     '-01-01'
  //   return { ...query, created_at }
  // }

  const getPost = async (filters = {}, page = 1) => {
    setTloading(true)
    try {
      const params = { ...filters }
      const { data } = await Postagens().show({
        page,
        ...params,
        'includes[]': 'leitor.user,obra,leitor.biblioteca',
        'orderBy[desc]': 'created_at'
      })

      setLastPage(data.last_page)
      setCurrentPage(data.current_page)

      setPost(FormatPostagens(data.data))
    } catch (e) {
      console.log(e)
    }
    setTloading(false)
  }

  const confirmDelete = async (id, leitor) => {
    await Swal.fire({
      title: 'Deletar Resumo',
      text: `Deseja deletar o resumo do leitor: ${leitor}?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar'
    }).then(result => {
      if (result.isConfirmed) {
        deletePost(id)
      }
    })
  }

  const deletePost = async id => {
    await Postagens()
      .destroyPostagemPlagio(id)
      .delete(
        {},
        { notification: true, message: 'leitura removida com sucesso!' }
      )
    getPost(query)
  }

  const getLector = () => {
    setQuery(
      Object.assign(query, {
        'includes[leitor.user][name]': `%${queryLector?.toUpperCase()}%`
      })
    )
    getPost(query)
  }

  const generateZip = data => {
    const blob = new Blob([data], { type: 'application/zip' })
    const blobURL = URL.createObjectURL(blob)
    window.open(blobURL)
  }

  const exportTxt = async filters => {
    const response = await Exportacao().show({
      ...filters,
      biblioteca_id: filters['includes[leitor.biblioteca][id]']
    })
    generateZip(response.data)
  }

  const handleClean = () => {
    if (queryLector !== '') {
      setQueryLector('')
      delete query.titulo
      delete query['includes[leitor.user][name]']
      getPost({ ...query, 'includes[leitor.user][name]': undefined })
    }
  }
  useEffect(() => {
    const filterGestao = localStorage.getItem('filterGestao')
    const objectFilter = JSON.parse(filterGestao)

    if (objectFilter !== null && Object.keys(objectFilter).length !== 0) {
      setQuery(objectFilter)
      setYear(
        objectFilter.ano_id && objectFilter.mes_id
          ? new Date(objectFilter.ano_id, objectFilter.mes_id - 1)
          : currentData
      )
      getPost(objectFilter)
    } else {
      const initialQuery = {
        mes_id: currentData.getMonth() + 1,
        ano_id: currentData.getFullYear()
      }
      setQuery(initialQuery)
      getPost(initialQuery)
    }
    getStatusPostagens()
  }, [])

  const postLog = async message => {
    await Logs().store({ acoes: message })
  }

  const pagination = gerarPaginacao(
    true,
    lastPage,
    currentPage,
    (event, value) => getPost(query, value)
  )

  const currentData = getMinDate()
  const [year, setYear] = useState(currentData)
  const [anoPostagem, setAnoPostagem] = useState(null)
  const MinDate = parseInt(Dater().formatar(new Date(), 'yyyy')) - 1 + '-01-01'
  const MaxDate = parseInt(Dater().formatar(new Date(), 'yyyy')) + '-12-31'

  const DatePickerClear = () => {
    setYear(null)
    const newQuery = { ...query }
    delete newQuery.ano_id
    delete newQuery.mes_id
    setQuery(newQuery)
    getPost(newQuery)
  }

  const AnoPostagemClear = () => {
    setAnoPostagem(null)
    const newQuery = { ...query }
    delete newQuery.ano_id
    delete newQuery.mes_id
    setQuery(newQuery)
    getPost(newQuery)
  }

  const [statusPostagens, setStatusPostagens] = useState([])

  const getStatusPostagens = async () => {
    try {
      const { data } = await StatusPostagens().show({ perPage: -1 })
      setStatusPostagens(data.data)
    } catch (e) {
      toast.warn('Falha ao buscar status de postagem')
      console.warn(e)
    }
  }

  const tipoChange = ({ value }) => {
    const bindFilter = {
      escrita: { video_path: 'null' },
      video: { resumo: 'null' }
    }
    let filter = {}

    if (value in bindFilter) {
      filter = bindFilter[value]
    }

    delete query?.resumo
    delete query?.video_path

    setQuery(Object.assign(query, filter))
    getPost(query)
  }

  const statusChange = ({ id }) => {
    setQuery(
      Object.assign(query, {
        status_postagem_id: id
      })
    )
    getPost(query)
  }

  const openImport = () => {
    inputRef.current.click()
  }

  const selectFiles = event => {
    const formData = new FormData()
    const file = [...event.target.files]

    formData.append(`files`, file[0])

    uplogFile(formData)
  }

  const uplogFile = async file => {
    const {
      data: { message }
    } = await Importacao().ArquivosPlagios(file)
    toast.success(message)
  }

  const routerCadastro = useNavigate()

  function anoPostagemChange(date) {
    setAnoPostagem(date)
    setYear(null) // Limpa o período
    const newQuery = {
      ...query,
      ano_id: date.$y
    }
    delete newQuery.mes_id
    setQuery(newQuery)
    getPost(newQuery)
  }

  function periodoChange(date) {
    setYear(date)
    setAnoPostagem(null) // Limpa o ano de postagem
    const newQuery = {
      ...query,
      ano_id: date.$y,
      mes_id: parseInt(date.$M) + 1
    }
    setQuery(newQuery)
    getPost(newQuery)
  }

  return (
    <DefaultPainel sx={{ mt: '4vh', p: 2 }}>
      <AdaptativeGridContainer>
        <>
          <TableHeader
            titulo="Lista de Leituras"
            controls={
              <MobileFilterHeaderContainer>
                <PrivateRC roles="bibliotecario">
                  <SmallTextField
                    color="white"
                    sx={{ marginRight: '15px' }}
                    type="text"
                    placeholder="Leitor"
                    variant="standard"
                    onKeyDown={() => {
                      clearTimeout(typingTimer)
                    }}
                    onKeyUp={() => {
                      clearTimeout(typingTimer)
                      typingTimer = setTimeout(getLector, 1000)
                    }}
                    onChange={({ target }) => {
                      setQueryLector(target.value)
                    }}
                    value={queryLector}
                    InputProps={{
                      style: { color: 'white' },
                      startAdornment: <SearchStartAdornment />,
                      endAdornment: AutoCompleteClear(handleClean)
                    }}
                  />
                </PrivateRC>
                <FilterButton
                  color="white"
                  onClick={() => {
                    routerCadastro(rotas.postagensCadastro)
                    postLog(
                      'Clicou no botão adicionar - Tela: Lista de Leituras'
                    )
                  }}
                  text="Adicionar"
                  Icon={Add}
                  bg="#000000BF"
                  sx={{ marginRight: '15px' }}
                />
                <BaseFilter
                  color="white"
                  filter={filter}
                  onChange={value => {
                    const newQuery = { ...query, ...value }
                    setQuery(newQuery)
                    getPost(newQuery)
                  }}
                  components={
                    <>
                      <BaseDatePicker
                        minDate={MinDate}
                        maxDate={MaxDate}
                        value={anoPostagem}
                        onChange={anoPostagemChange}
                        label="Ano de Postagem"
                        inputFormat="YYYY"
                        openTo="year"
                        views={['year']}
                        onClear={AnoPostagemClear}
                        inputProps={{
                          sx: { mb: '1rem' }
                        }}
                      />
                      <BaseDatePicker
                        minDate={MinDate}
                        maxDate={MaxDate}
                        value={year}
                        onChange={periodoChange}
                        label="Período"
                        inputFormat="MM/YYYY"
                        openTo="year"
                        views={['year', 'month']}
                        onClear={DatePickerClear}
                        inputProps={{
                          sx: { mb: '1rem' }
                        }}
                      />
                      <BaseAutoComplete
                        list={tipoOptions}
                        sx={{ mb: '1rem' }}
                        listLabel="descricao"
                        inputProps={{ label: 'Tipo', color: 'default' }}
                        onChange={tipoChange}
                      />
                      <BaseAutoComplete
                        list={statusPostagens}
                        listLabel="descricao"
                        inputProps={{ label: 'Status', color: 'default' }}
                        onChange={statusChange}
                      />
                    </>
                  }
                />
                <PrivateRC roles="gestor">
                  <FilterButton
                    color="white"
                    onClick={() => {
                      exportTxt(query)
                    }}
                    text="Baixar TXT"
                    Icon={FileDownload}
                    bg="#000000BF"
                    sx={{ marginRight: '15px' }}
                  />
                </PrivateRC>
                <PrivateRC roles="gestor">
                  <FilterButton
                    color="white"
                    onClick={() => {
                      openImport()
                    }}
                    text="Plágio"
                    Icon={FileUpload}
                    bg="#000000BF"
                    sx={{ marginRight: '15px' }}
                  />
                </PrivateRC>
                <input
                  type="file"
                  ref={inputRef}
                  onChange={selectFiles}
                  hidden
                  multiple
                />
              </MobileFilterHeaderContainer>
            }
          />
          <Grid item xs={12} sm={12}>
            <Divider />
            <StyledBaseDatagrid
              pagination={pagination}
              rows={post}
              columns={headers}
              loading={tloading}
              rowsPerPageOptions={[10]}
              disableColumnMenu
              disableColumnSelector
            />
          </Grid>
        </>
      </AdaptativeGridContainer>
    </DefaultPainel>
  )
}
export default Postagem
